import { useEffect, useState } from "react";
import SideBar from "./components/SideBar";
import Header from "../src/components/Header";
import Footer from "../src/components/Footer";
import { Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/360View/360Dashboard/Dashboard";
import Sidebar360 from "./pages/360View/360Sidebar/Sidebar360";

function App() {
  const [showDashboard, setShowDashboard] = useState(false);
  const divCollapsed = localStorage.getItem("div-collapsed") || true;

  useEffect(() => {
    const flag = localStorage.getItem("isMainUser");
    const selectedUseCase = localStorage.getItem("selectedUseCase");

    // Show Dashboard only if multiAccess is true AND no useCase selected yet
    if (flag == "true" && !selectedUseCase) {
      setShowDashboard(true);
    } else {
      setShowDashboard(false);
    }
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        bodyClassName="toastBody"
      />

      {showDashboard ? (
        <Dashboard onUseCaseSelect={() => setShowDashboard(false)} />
      ) : (
        <div className="app-container">
          <div
            className={`${
              divCollapsed ? "sidebar-container-coll" : " sidebar-container"
            }`}
          >
            <Sidebar360 />
          </div>
          <div className="content-container">
            <div className="wrapper">
              <Header />
              <Outlet />
              <Footer />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;